
import React, { Component } from 'react';
import { HashRouter as Router, Route, Redirect } from "react-router-dom";

import MenuPrincipal from './MenuPrincipal'

import Loading from './Loading'
//import ModalAlertPoints from './ModalAlertPoints'

// import CoordenadorPage from './coordenador/CoordenadorPage';
// import AdminPage from './admin/AdminPage';
// import AlunoPage from './aluno/AlunoPage';

import UserPage from '../auth/UserPage';
import QuestoesPage from './aluno/QuestoesPage';

import { Subscribe } from 'unstated'
import UserContainer from '../containers/user.container'

import Alert from 'react-s-alert';

import GAListener from '../analytics/GAListener'

class App extends Component {

  _userPhotoSize = 36
  state = {
    carregado: false
  }

  async componentDidMount() {

    //Force disable login
     //this.props.userContainer.setState({isLoggedIn: true, loadingProfile: false})
     //return;

    await this.props.userContainer.login();
    // se estiver autenticado, realizar chamadas dos serviços base do usuário
    if (this.props.userContainer.state.isLoggedIn) {
      // serviço parar recuperar os dados do perfil
      await this.props.userContainer.fetchProfile()
      // serviço para recuperar a foto da NavBar
      await this.props.userContainer.getUserPhotoBySize(this._userPhotoSize)
      // serviço para recuperar o menu do usuário
      await this.props.userContainer.getMenu()

      await this.props.userContainer.getQtdNotifications();
      //await this.props.userContainer.getCientAlertPoints();
      this.setState({ carregado: true});
    }
  }

  // isUserCoordenador() {
  //   if(!this.props.userContainer.state.profile) {
  //       return false;
  //   }
  //   var profileList = this.props.userContainer.state.profile.profilelist
  //   if (profileList) {
  //     var profiles = profileList.split(',').map(p => p.trim())
  //     return profiles.indexOf('Coordenador') > -1
  //   }
  //   return false;
  // }

  // isUserAdmin() {
  //   if(!this.props.userContainer.state.profile) {
  //       return false;
  //   }
  //   var profileList = this.props.userContainer.state.profile.profilelist
  //   if (profileList) {
  //     var profiles = profileList.split(',').map(p => p.trim())
  //     return profiles.indexOf('EdebêLab') > -1
  //   }
  //   return false;
  // }

  render() {
    // let page = UserPage(this.props.userContainer);
    // console.log('page', page);
    return (
      <>
        {this.props.userContainer.state.isLoggedIn &&
          <MenuPrincipal
            profile={this.props.userContainer.state.profile}
            photo={this.props.userContainer.state.photo[this._userPhotoSize]}
            menu={this.props.userContainer.state.menu}
            alertas={this.props.userContainer.state.notifications.amount}
            onLogout={this.props.userContainer.logout}
            body={
              <>
                <Alert timeout={10000} position='top' stack={true} effect='stackslide' />
                {/*<ModalAlertPoints isOpen={!this.props.userContainer.state.openModalCientAlertPoints && this.state.carregado}*/}
                {/*              style={{ width: "320px", marginTop: "40px" }}*/}
                {/*              title="Atenção"*/}
                {/*              content={<div>*/}
                {/*                <p>Prezados,</p>*/}
                {/*                <p>A partir do dia 29/07/2020 a sua pontuação na plataforma adaptativa será reajustada*/}
                {/*                  conforme a tabela (link da Wiki), pois foram verificadas inconsistências na pontuação atual.*/}
                {/*                  Agradecemos a compreensão,</p>*/}
                {/*              </div>}*/}
                {/*              confirmText="Ciente"*/}
                {/*              onClickConfirm={this.props.userContainer.setCientAlertPoints}/>*/}

                {this.props.userContainer.state.loadingProfile && <Loading text="Carregando..." />}
                {!this.props.userContainer.state.loadingProfile &&
                  <Router>
                    <GAListener>
                      <Route path="/" exact render={() => {
                        if (this.props.userContainer.state.redirectTo)
                          return <Redirect to={this.props.userContainer.state.redirectTo} />
                        return <Redirect to="/app" />
                      }} />
                      <Route path="/app" component={UserPage(this.props.userContainer)} />
                      {/*<Route path="/app" component={this.isUserAdmin() ? AdminPage : ( this.isUserCoordenador() ? CoordenadorPage : AlunoPage )} />*/}
                      <Route path="/simulado/:idExam" component={QuestoesPage} />
                    </GAListener>
                  </Router>
                }
              </>
            }
          />
        }
      </>
    );
  }
}

// higher order component
export default () => (<Subscribe to={[UserContainer]}>
  {user => <App userContainer={user} />}
</Subscribe>);
